<template>
  <div class="alert alert-success alert-dismissible fade show custom-alert p-2 mb-3" role="alert">
    {{ $t("dashboard.LanguageChangeOptionisAvailableIn") }}
    <a class="profileLink" :href="PROFILE" target="_blank">{{ $t("userSideMenuV1.myProfile") }}</a>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div>
    <div class="row mb-3">
      <div class="col-12">
        <DashboardSummaryTiles :summaryTilesData="summaryTilesData" />
      </div>
      <div class="col-12">
        <StyleAnalysesChart></StyleAnalysesChart>
      </div>
    </div>
    <div class="dashboard-two-section">
      <div class="dashboard-section">
        <ProductWiseSgcConsumption />
      </div>

      <div class="dashboard-section">
        <StylesCreatedForCustomers />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import DashboardSummaryTiles from "@/app/views/_components/DashboardSummaryTiles.vue";
import StylesCreatedForCustomers from "@/app/views/_components/dashboard/StylesCreatedForCustomers.vue";
import ProductWiseSgcConsumption from "@/app/views/_components/dashboard/ProductWiseSgcConsumption.vue";
import { DashboardApi } from "@/api";
import { eventBus } from "@/main";
import { defineComponent } from "vue";
import { useToast } from "vue-toastification";
import { useRoute, useRouter } from "vue-router";
import getEnv from "@/core/utils/env";
import StyleAnalysesChart from "@/app/views/_components/StyleAnalysesChart.vue";

export default defineComponent({
  name: "Dashboard",
  setup() {
    const dashboardApi = new DashboardApi()!;

    return {
      dashboardApi
    };
  },
  components: {
    DashboardSummaryTiles,
    StyleAnalysesChart,
    StylesCreatedForCustomers,
    ProductWiseSgcConsumption
  },
  data() {
    return {
      toast: null as any,
      route: useRoute(),
      router: useRouter(),
      summaryTilesData: {
        styleAnalysis: {
          count: 0,
          latestStyleNames: [] as string[]
        },
        customers: {
          count: 0,
          topCustomerNames: [] as string[]
        },
        productType: {
          count: 0,
          productCategoriesCount: 0
        },
        settings: {
          count: 0,
          latestSettingNames: [] as string[]
        }
      }
    };
  },
  computed: {
    PROFILE(): string {
      return getEnv("VUE_APP_CD_PLATFORM_PROFILE");
    }
  },
  created(): void {
    this.toast = useToast();
    this.loadSummaryTiles();
    eventBus.emit("pageName", "Dashboard");
  },
  mounted(): void {
    if (this.route.query.error) {
      this.toast.error(this.route.query.error as string, {
        toastClassName: "custom-error-toast",
        timeout: 5000
      });
      this.router.replace({ query: null } as any);
    }
  },
  methods: {
    async loadSummaryTiles(): Promise<void> {
      try {
        const res = await this.dashboardApi.apiDashboardSummaryTilesGet();
        this.summaryTilesData = {
          styleAnalysis: {
            count: res.data.styleAnalysisCount ?? 0,
            latestStyleNames: res.data.latestStyleNames ?? []
          },
          customers: {
            count: res.data.customersCount ?? 0,
            topCustomerNames: res.data.topCustomerNames ?? []
          },
          productType: {
            count: res.data.productTypesCount ?? 0,
            productCategoriesCount: res.data.productCategoriesCount ?? 0
          },
          settings: {
            count: res.data.settingsCount ?? 0,
            latestSettingNames: res.data.latestSettingNames ?? []
          }
        };
      } catch {
        this.toast?.error(this.$t("dashboard.summaryTilesLoadError"), {
          toastClassName: "custom-error-toast",
          timeout: 5000
        });
      }
    }
  }
});
</script>
<style>
.dottedBox {
  border: 2px dotted gray;
  border-radius: 15px;
  margin: 8px;
  padding: 10px;
  background: #f7f7f7;
  color: #706f6fda;
}
.app-config-loader {
  background-color: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
}

.loading-text {
  position: absolute;
  top: calc(50% + 50px);
  left: 50%;
  transform: translate(-50%, -50%);
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.custom-success-toast {
  background-color: #cfedeaf8 !important;
  color: #216b5d !important;
  font-size: 14px !important;
  width: 400px;
}
.custom-error-toast {
  background-color: #f6dde2f2 !important;
  color: #7f323b !important;
  font-size: 14px !important;
  width: 400px;
}
.Vue-Toastification__container {
  z-index: 12002 !important;
  position: fixed;
  padding: 4px;
  box-sizing: border-box;
  display: flex;
  min-height: 100%;
  color: #fff;
  flex-direction: column;
  font-family: Arial, Helvetica, sans-serif;
}
.Vue-Toastification__close-button {
  color: rgb(8, 8, 8) !important;
}
body {
  font-family: Arial, Helvetica, sans-serif !important;
}
.alert-success {
  color: #3c763d;
  background-color: #d1f0ea !important;
  border-color: #d6e9c6;
}
.custom-alert {
  margin-top: -1rem !important;
  padding: 0.5rem 1rem !important;
  margin-bottom: 1rem !important;
  font: 12px;
}
.custom-alert .close {
  padding: 0.5rem 0.75rem !important;
  margin-top: 0.1rem !important;
}
.profileLink {
  color: #0054a6;
  font-weight: 500;
  text-decoration: none;
}
.dashboard-two-section {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 50% / 50% */
  gap: 20px;
  margin-bottom: 20px;
}
.dashboard-section {
  min-width: 0;
  height: auto;
}

.dashboard-section > * {
  width: 100%;
  height: 100%;
}

@media (max-width: 992px) {
  .dashboard-two-section {
    grid-template-columns: 1fr;
  }
}
.dropdown-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}
</style>
